const Backbone = window.Backbone;

import TitleInfoListView from './views/TitleInfoListView';
import TitleActionButton from './TitleActionButton';
import WishListButton from './WishListButton';
import Cover from './Cover';
import TitleDescription from './views/TitleDescription.js';
import TitleCardListTemplate from './templates/TitleCardListView.html';

const TitleCardListView = Backbone.View.extend({
    className: 'title-container',

    template: TitleCardListTemplate,

    initialize({ bus, coverWidths }) {
        const model = this.model;

        const $tmp = $(this.template());

        this.cover = new Cover({
            model,
            el: $tmp.find('.CoverImage'),
            coverWidths,
            isInHero: false,
        });

        this.titleInfo = new TitleInfoListView({
            model,
            el: $tmp.find('.TitleInfo'),
        });

        this.titleActionButton = new TitleActionButton({
            model,
            el: $tmp.find('.TitleAction'),
            type: 'button',
            style: 'fill',
        });

        if (
            !window.featureManager.isEnabled('sampleOnlyMode') &&
            !this.model.isMagazine &&
            !window.featureManager.isEnabled('disableWishlist')
        ) {
            this.wishlistButton = new WishListButton({
                model,
                el: $tmp.find('.TitleWishlist'),
                type: 'with-text',
            }).render();
        }

        this.titleDescription = new TitleDescription({
            model,
            el: $tmp.find('.title-description'),
        });

        this.$el.html($tmp);
    },
});

module.exports = TitleCardListView;
